import { makeActionCreator } from '../App_Code/Utils';
import { ActDoc } from '../App_Data/ActionTypes';

export const docAjout = makeActionCreator(ActDoc.DOC_AJOUT, 'data');

export const docFiltreObjet = makeActionCreator(ActDoc.DOC_FILTRE_OBJET, 'data');

export const docFiltrePrest = makeActionCreator(ActDoc.DOC_FILTRE_PREST, 'data');

export const docFiltreAct = makeActionCreator(ActDoc.DOC_FILTRE_ACT, 'data');

export const docFiltresSuppression = makeActionCreator(ActDoc.DOC_FILTRES_SUPPR);



// WEBPACK FOOTER //
// ./src/Actions/DocActions.js